import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { AlertCircle } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-white to-[#F8FAFB] p-4">
          <Card className="max-w-md border-[#EF4444] shadow-2xl">
            <CardContent className="pt-12 pb-8 text-center">
              <div className="flex justify-center mb-6">
                <div className="w-20 h-20 bg-[#EF4444] rounded-full flex items-center justify-center">
                  <AlertCircle className="w-12 h-12 text-white" />
                </div>
              </div>
              <h1 className="text-3xl font-bold text-[#2C3E50] mb-4">
                Úps! Eitthvað fór úrskeiðis
              </h1>
              <p className="text-[#8B9BA8] mb-8">
                Villa kom upp. Vinsamlegast endurhlaðaðu síðunni eða farðu aftur á forsíðu.
              </p>
              <div className="space-y-3">
                <Button 
                  onClick={() => window.location.reload()}
                  className="w-full bg-[#0A4D8C] hover:bg-[#083A6B] text-white py-6"
                >
                  Endurhlaða síðu
                </Button>
                <Button 
                  onClick={() => window.location.href = '/'}
                  variant="outline"
                  className="w-full border-2 border-[#0A4D8C] text-[#0A4D8C] py-6"
                >
                  Fara á forsíðu
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
